
// SCROLL REVEAL
(function(){
  const io=new IntersectionObserver((entries)=>{
    entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('visible');io.unobserve(e.target);}});
  },{threshold:0.1,rootMargin:'0px 0px -40px 0px'});
  document.querySelectorAll('.reveal,.reveal-left,.reveal-right').forEach(el=>io.observe(el));
})();

// PREVIEW VIEWER
(function(){
  const imgs=window.__NI_PREV||[];
  let cur=0;
  const imgEl=document.getElementById('pvImg');
  const counter=document.getElementById('pvCounter');
  const prev=document.getElementById('pvPrev');
  const next=document.getElementById('pvNext');
  const wrap=document.getElementById('pvWrap');

  // Preload all preview images so clicks are instant
  imgs.forEach(src=>{ const img=new Image(); img.src=src; });

  function go(i){
    cur=Math.max(0,Math.min(i,imgs.length-1));
    imgEl.src=imgs[cur];
    imgEl.alt='Página '+(cur+1)+' del ebook Manifestalo TODO';
    counter.textContent=(String(cur+1).padStart(2,'0'))+' / '+imgs.length;
    prev.disabled=cur===0;
    next.disabled=cur===imgs.length-1;
  }
  prev.onclick=()=>go(cur-1);
  next.onclick=()=>go(cur+1);
})();

// TESTIMONIOS CAROUSEL
(function(){
  const track=document.getElementById('testiTrack');
  const allCards=[...track.children];
  const total=allCards.length;
  let cur=0,startX=0,isDrag=false,dragStart=0;

  function perView(){
    const w=window.innerWidth;
    if(w<560)return 1;
    if(w<900)return 2;
    return 4;
  }

  function go(i){
    const pv=perView();
    const max=Math.max(0,total-pv);
    cur=Math.max(0,Math.min(i,max));
    const cardW=allCards[0].getBoundingClientRect().width;
    const gap=14;
    track.style.transform=`translateX(-${cur*(cardW+gap)}px)`;
    document.getElementById('testiPrev').disabled=cur===0;
    document.getElementById('testiNext').disabled=cur>=max;
  }

  document.getElementById('testiPrev').onclick=()=>go(cur-1);
  document.getElementById('testiNext').onclick=()=>go(cur+1);

  track.addEventListener('touchstart',e=>{startX=e.touches[0].clientX;},{passive:true});
  track.addEventListener('touchend',e=>{
    const dx=e.changedTouches[0].clientX-startX;
    if(Math.abs(dx)>40)go(dx<0?cur+1:cur-1);
  });
  track.addEventListener('mousedown',e=>{isDrag=true;dragStart=e.clientX;track.classList.add('dragging');});
  document.addEventListener('mouseup',e=>{
    if(isDrag){
      const dx=e.clientX-dragStart;
      if(Math.abs(dx)>40)go(dx<0?cur+1:cur-1);
      isDrag=false;track.classList.remove('dragging');
    }
  });
  window.addEventListener('resize',()=>go(cur));
})();

// FAQ
document.querySelectorAll('.fi-q').forEach(btn=>{
  btn.addEventListener('click',()=>{
    const item=btn.parentElement;
    const isOpen=item.classList.contains('open');
    document.querySelectorAll('.fi').forEach(i=>i.classList.remove('open'));
    if(!isOpen)item.classList.add('open');
  });
});

// VALUE STACK animations
(function(){
  // Animate product cards in
  const cards = document.querySelectorAll('.vs-product-card');
  const rowsAll = document.querySelectorAll('.vs-row');
  const revealBox = document.querySelector('.vs-reveal-box');

  const io = new IntersectionObserver((entries) => {
    entries.forEach((e, idx) => {
      if (!e.isIntersecting) return;
      const el = e.target;
      if (el.classList.contains('vs-product-card')) {
        const delay = el === cards[0] ? 0 : 120;
        setTimeout(() => el.classList.add('vs-visible'), delay);
        // stagger rows inside
        const rows = el.querySelectorAll('.vs-row');
        rows.forEach((r, i) => setTimeout(() => r.classList.add('vs-visible'), delay + 80 + i * 45));
      } else if (el.classList.contains('vs-reveal-box')) {
        setTimeout(() => el.classList.add('vs-visible'), 0);
        // count-up inside
        el.querySelectorAll('.vs-count').forEach(counter => {
          const target = parseInt(counter.dataset.target, 10);
          let start = null;
          const dur = 900;
          const step = (ts) => {
            if (!start) start = ts;
            const pct = Math.min((ts - start) / dur, 1);
            const ease = 1 - Math.pow(1 - pct, 3);
            counter.textContent = 'USD ' + Math.round(ease * target);
            if (pct < 1) requestAnimationFrame(step);
          };
          setTimeout(() => requestAnimationFrame(step), 200);
        });
      }
      io.unobserve(el);
    });
  }, {threshold: 0.15});

  cards.forEach(c => io.observe(c));
  if (revealBox) io.observe(revealBox);

  // Also count-up subtotal vals
  const subCounts = document.querySelectorAll('.vs-sub .vs-count');
  const subIo = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      const counter = e.target;
      const target = parseInt(counter.dataset.target, 10);
      let start = null;
      const dur = 700;
      const step = (ts) => {
        if (!start) start = ts;
        const pct = Math.min((ts - start) / dur, 1);
        const ease = 1 - Math.pow(1 - pct, 3);
        counter.textContent = 'USD ' + Math.round(ease * target);
        if (pct < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
      subIo.unobserve(counter);
    });
  }, {threshold: 0.5});
  subCounts.forEach(c => subIo.observe(c));
})();

